import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { bytesToHuman } from "Utils/bytesFormats";
import DetailInfo from "Components/detailInfo/DetailInfo";
import QboxmailApi from "../../qboxmailApi";
import { Icon, arrowDown, arrowUp, attach, mail, flag } from "Icons/index";
import { t } from "i18next";
import Tooltip from "Components/tooltip/Tooltip";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import cx from "classnames";
import TranslatedString from "Components/TranslatedString";
import s from "./etliveLog.scss";

const emojiFlags = require("emoji-flags");

const ACTIVE_SYNC_IP = "185.97.217.63";

const ContextTypes = {
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class ETLiveLog extends Component {
  constructor(props) {
    super(props);
    this.client = new QboxmailApi({ useCookie: true });
    this.state = {
      selectedLog: null,
      expanded: false,
      expandedDelivery: false,
      expandedAttach: false,
      expandedNotification: false,
      censorPrivateFields:
        props.loggedUserType != "EmailAccount" &&
        props.loggedUserType != "Admin" &&
        props.loggedUserType != "Postmaster",
    };
  }

  toggleExpansion = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  toggleDelivery = () => {
    this.setState({ expandedDelivery: !this.state.expandedDelivery });
  };

  toggleAttach = () => {
    this.setState({ expandedAttach: !this.state.expandedAttach });
  };

  toggleNotification = () => {
    this.setState({ expandedNotification: !this.state.expandedNotification });
  };

  getCensoredField = (field) => {
    if (this.state.censorPrivateFields) {
      return "*****";
    }
    return field;
  };

  whereIs = (log) => {
    let key = `${log._id}_where_inprogress`;
    this.setState({ [key]: true });

    console.log(log, "wowo");

    this.client
      .ETliveWhere({
        domain: this.props.domainCode,
        user: log.user,
        msg_id: log.msgid,
      })
      .then((folder) => {
        this.setState({ [key]: false, whereIsFolder: folder, selectedLog: log });
      })
      .catch((e) => {
        console.log(e, "locatingError");

        if (e.status === 404) {
          this.setState({ [key]: false, whereIsNotFound: true, selectedLog: log });
        } else {
          window.alert(t("etlive.log.locatingError"));
        }

        this.setState({ [key]: false });
      });
  };

  exportPDF = (log, extra) => {
    let key = `${log._id}_exporting`;
    this.setState({ [key]: true });

    this.client
      .exportETlivePDF({
        format: "pdf",
        log: { ...log, ...extra },
      })
      .then((r) => {
        if (r.result === "ok") {
          window.open(BASE_URL_PUBLIC_ASSETS + r.file_path, "_blank");
        } else {
          window.alert(t("etlive.log.exportingError"));
        }

        this.setState({ [key]: false });
      })
      .catch((e) => {
        window.alert(t("etlive.log.exportingError"));
        this.setState({ [key]: false });
      });
  };

  formatAttachments = (rawString) => {
    if (rawString.includes("****")) {
      return [{ name: "*****", size: "*****" }];
    }

    const re = /([^:]*):(\d*);/g;
    let formatteds = [];
    let res;
    while ((res = re.exec(rawString)) !== null) {
      formatteds.push({ name: res[1], size: res[2] });
    }

    return formatteds;
  };

  isAdminUser = () => this.props.loggedUserType === "Admin";

  renderBounces = (bounces) => {
    return (
      <div className={s.contentAccordion}>
        {_.map(bounces, (obj, k) => (
          <div className={s.singleNotification} key={`${obj.datetime}${obj.to}`}>
            <div
              className={cx(s.statusNotification, {
                [s.red]: obj.kind && obj.kind !== "delivery",
              })}
            >
              <span>{obj.kind}</span>
            </div>

            <div className={s.infoNotification}>
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.date")}
                info={obj.datetime_in_timezone && new Date(obj.datetime_in_timezone).toLocaleString()}
              />

              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.smtpID")} info={k} />

              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.reason")}
                info={
                  obj.kind === "delivery" ? "sender delivery status notification" : "sender non-delivery notification"
                }
              />

              <div className={cx(s.titleSection, s.infoFull2)}>{t("etlive.log.accordion.notification.deliveries")}</div>

              <div className={s.infoFull2}>{obj.deliveries && this.renderDeliveries(obj.deliveries, obj.msg_id)}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderDeliveries = (deliveries, msgId = null) => {
    return (
      <div className={s.contentAccordion}>
        {_.map(deliveries, (obj) => (
          <div className={s.singleDelivery} key={`${obj.datetime}${obj.to}`}>
            <div
              className={cx(s.statusDelivery, {
                [s.red]: obj.status === "bounced",
                [s.yellow]: obj.status === "deferred",
              })}
            >
              <span>{obj.status}</span>
            </div>

            <div className={s.infoDelivery}>
              <DetailInfo
                className={cx(s.detailInfo, s.detailInfoFull)}
                label={t("detailInfo.label.date")}
                info={obj.datetime_in_timezone && new Date(obj.datetime_in_timezone).toLocaleString()}
              />

              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.to")} info={obj.to} />

              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.DSN")} info={obj.dsn} />

              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.delay")} info={obj.delay} />

              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.relay")} info={obj.relay} />

              <DetailInfo
                className={cx(s.detailInfo, s.detailInfoFull)}
                label={t("detailInfo.label.response")}
                info={obj.response}
              />

              {msgId && (
                <DetailInfo
                  className={cx(s.detailInfo, s.detailInfoFull)}
                  label={t("detailInfo.label.messageID")}
                  info={msgId}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderDeliveriesMailins = (deliveries, colorClass) => {
    return (
      <div className={s.contentAccordion}>
        {_.map(deliveries, (obj, i) => {
          let color = colorClass;

          let action = obj.action;
          if (obj.action === "storeerror") {
            color = s.red;
          }

          if (obj.action === "vacationerror") {
            color = s.yellow;

            if (obj.errormsg === "discarded duplicate vacation response") {
              action = "vacation messsage already sent before";
            }
          }

          return (
            <div className={s.singleDelivery} key={`${obj.datetime}${obj.to}${i}`}>
              <div className={cx(s.statusDelivery, { [color]: true })}>
                <span>received</span>
              </div>
              <div className={s.infoDelivery}>
                <DetailInfo
                  className={cx(s.detailInfo, s.detailInfoFull)}
                  label={t("detailInfo.label.date")}
                  info={obj.datetime_in_timezone && new Date(obj.datetime_in_timezone).toLocaleString()}
                />

                <DetailInfo className={s.detailInfo} label={t("detailInfo.label.action")} info={action} />

                <DetailInfo
                  className={s.detailInfo}
                  label={t("detailInfo.label.detail")}
                  info={obj.action === "storeerror" && obj.errormsg ? obj.errormsg : obj.detail}
                />

                <DetailInfo className={s.detailInfo} label={t("detailInfo.label.serverDelivery")} info={obj.server} />
                <DetailInfo className={s.detailInfo} label={t("detailInfo.label.session")} info={obj.session} />

                <DetailInfo
                  className={s.detailInfo}
                  label={t("detailInfo.label.deliverytime")}
                  info={obj.deliverytime}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  generateClientString = (log) => {
    const isAdmin = this.props.loggedUserType == "Admin";
    if (log.webmail_access && isAdmin) {
      return (
        <span>
          Webmail <span className={s.webmailVersion}>({log.webmail_version})</span> - {log.webmail_server}
          <span className={s.webmailVersion}>({log.webmail_rip})</span>
        </span>
      );
    } else if (log.webmail_access && !isAdmin) {
      return <span>Webmail</span>;
    } else if (log.rip === ACTIVE_SYNC_IP) {
      return <span>Microsoft® Exchange ActiveSync</span>;
    } else {
      return log.client;
    }
  };

  renderAccess = (log) => {
    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    // const webmailIps = ["185.97.217.231", "185.97.217.64", "185.97.217.65"];
    const hasError = log.login_error != "";

    let action;
    if (log.login && log.logout) action = "Login + Logout";
    if (log.login && !log.logout) action = "Login";
    if (!log.login && log.logout) action = "Logout";
    if (!log.login && !log.logout) action = "Error";

    return (
      <div className={cx(s.wrapLog, s.access, { [s.failed]: hasError })}>
        <div className={s.headerLog}>
          <div className={s.statusCircle} />
          <div className={s.titleHeader}>{t("etlive.log.title.accesss")}</div>

          <div
            onClick={() => this.exportPDF(log, { type: "access", action })}
            className={cx(s.btnExport, "internalLink", {
              [s.exporting]: this.state[`${log._id}_exporting`],
            })}
          >
            {this.state[`${log._id}_exporting`]
              ? t("etlive.log.exporting")
              : isMediaMobile()
              ? t("etlive.log.exportPDF")
              : t("etlive.log.export")}
          </div>
          <div className={cx(s.btnMore, "internalLink")} onClick={this.toggleExpansion}>
            {this.state.expanded ? t("butto.info.hide") : t("butto.info.show")}
          </div>
        </div>
        <div className={s.contentLog}>
          <DetailInfo className={s.detailInfo} label={t("detailInfo.label.action")} info={action} />

          <DetailInfo className={s.detailInfo} label={t("detailInfo.label.user")} info={log.user + "@" + log.domain} />

          <DetailInfo
            className={cx(s.detailInfo, {
              [s.detailInfoFull]: !log.logout && !log.login_error,
            })}
            label={t("detailInfo.label.login.date")}
            info={log.login && log.login_at ? new Date(log.login_at_in_timezone).toLocaleString() : "—"}
          />

          {log.logout && !log.login_error && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.logout.date")}
              info={log.logout_at_in_timezone ? new Date(log.logout_at_in_timezone).toLocaleString() : "—"}
            />
          )}

          {log.login_error && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.login.error")}
              info={log.login_error}
              error
            />
          )}

          <DetailInfo
            className={s.detailInfo}
            label={t("detailInfo.label.client")}
            info={this.generateClientString(log)}
          />

          {log.rip_country_code && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.country")}
              info={
                <Tooltip
                  title={t("tooltip.country")}
                  text={emojiFlags[log.rip_country_code].name}
                  containerStyle={{ float: "right" }}
                >
                  <span className={s.flag}>{emojiFlags[log.rip_country_code].emoji}</span>
                </Tooltip>
              }
            />
          )}

          <DetailInfo
            className={cx(s.detailInfo, s.detailInfoFull)}
            label={t("detailInfo.label.protocol")}
            info={log.protocol}
          />

          {this.state.expanded && (log.protocol === "imap" || log.protocol === "webmail") && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.msg.deleted")}
              info={log.imap_deleted_msgs}
            />
          )}

          {this.state.expanded && (log.protocol === "imap" || log.protocol === "webmail") && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.msg.expunged")}
              info={log.imap_expunged_msgs}
            />
          )}

          {this.state.expanded && (log.protocol === "imap" || log.protocol === "webmail") && (
            <DetailInfo
              className={cx(s.detailInfo, s.detailInfoFull)}
              label={t("detailInfo.label.msg.trashed")}
              info={log.imap_trashed_msgs}
            />
          )}

          {this.state.expanded && log.protocol === "pop3" && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.msg.deleted")}
              info={log.pop_deleted_msgs}
            />
          )}

          {this.state.expanded && log.protocol === "pop3" && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.msg.expunged")}
              info={log.pop_expunged_msgs}
            />
          )}

          {this.state.expanded && log.protocol === "pop3" && (
            <DetailInfo
              className={cx(s.detailInfo, s.detailInfoFull)}
              label={t("detailInfo.label.msg.trashed")}
              info={log.pop_trashed_msgs}
            />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.traffic.in")}
              info={bytesToHuman(log.in_traffic, true)}
            />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.traffic.out")}
              info={bytesToHuman(log.out_traffic, true)}
            />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.localIP")} info={log.lip} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.remoteIP")} info={log.rip} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.server")} info={log.server} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.session")} info={log.sid} />
          )}
        </div>
      </div>
    );
  };

  formatSubject = (s) => {
    if (!s) return "****";
    return s.length > 20 ? s.slice(0, 20) + "..." : s;
  };

  maskIp = (ip) => {
    let parts = ip.split(".");
    parts[2] = parts[2].replace(/[\w\d]/g, "*");
    parts[3] = parts[3].replace(/[\w\d]/g, "*");
    return parts.join(".");
  };

  renderMailout = (log) => {
    const { isMediaMobile } = this.context;

    let port;
    if (log.protocol === "smtp") port = 25;
    if (log.protocol === "smtps") port = 465;
    if (log.protocol === "submission") port = 587;

    let colorClass;
    const mailFailed = log.reject_message !== "" || log.auth_error !== "";

    if (mailFailed) {
      colorClass = s.failed;
    } else if (log.bounces) {
      colorClass = s.warning;
    }

    // if message is rejected, don't show deliveries
    let showDeliveries = log.reject_message == "";

    if (log.auth_error) {
      return (
        <div className={cx(s.wrapLog, s.mailOut, { [colorClass]: true })}>
          <div className={s.headerLog}>
            <div className={s.statusCircle} />
            <div className={s.titleHeader}>
              {mailFailed ? t("etlive.log.title.email.not.sent") : t("etlive.log.title.email.sent")}
            </div>
            <div
              onClick={() => this.exportPDF(log, { type: "mailout" })}
              className={cx(s.btnExport, "internalLink", {
                [s.exporting]: this.state[`${log._id}_exporting`],
              })}
            >
              {this.state[`${log._id}_exporting`]
                ? t("etlive.log.exporting")
                : isMediaMobile()
                ? t("etlive.log.exportPDF")
                : t("etlive.log.export")}
            </div>
          </div>
          <div className={s.contentLog}>
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.date")}
              info={log.datetime_in_timezone && new Date(log.datetime).toLocaleString()}
            />

            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.user")}
              info={log.user + "@" + log.domain}
            />

            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.server")} info={log.server} />

            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.remoteIP")} info={log.sip} />

            <DetailInfo
              className={cx(s.detailInfo)}
              label={t("detailInfo.label.error.authentication")}
              info={log.auth_error}
              error
            />

            {log.sip_country_code && (
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.country")}
                info={
                  <Tooltip
                    title={t("tooltip.country")}
                    text={emojiFlags[log.sip_country_code].name}
                    containerStyle={{ float: "right" }}
                  >
                    <span className={s.flag}>{emojiFlags[log.sip_country_code].emoji}</span>
                  </Tooltip>
                }
              />
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={cx(s.wrapLog, s.mailOut, { [colorClass]: true })}>
        <div className={s.headerLog}>
          <div className={s.statusCircle} />
          <div className={s.titleHeader}>
            {mailFailed ? t("etlive.log.title.email.not.sent") : t("etlive.log.title.email.sent")}
          </div>
          <div
            onClick={() => this.exportPDF(log, { type: "mailout" })}
            className={cx(s.btnExport, "internalLink", {
              [s.exporting]: this.state[`${log._id}_exporting`],
            })}
          >
            {this.state[`${log._id}_exporting`]
              ? t("etlive.log.exporting")
              : isMediaMobile()
              ? t("etlive.log.exportPDF")
              : t("etlive.log.export")}
          </div>
          <div className={cx(s.btnMore, "internalLink")} onClick={this.toggleExpansion}>
            {this.state.expanded ? t("butto.info.hide") : t("butto.info.show")}
          </div>
        </div>
        <div className={s.contentLog}>
          <DetailInfo
            className={s.detailInfo}
            label={t("detailInfo.label.date")}
            info={log.datetime_in_timezone && new Date(log.datetime_in_timezone).toLocaleString()}
          />

          <DetailInfo className={s.detailInfo} label={t("detailInfo.label.user")} info={log.user + "@" + log.domain} />

          <DetailInfo className={s.detailInfo} label={t("detailInfo.label.from")} info={log.from} />

          {parseInt(log.nrcpt, 10) == 1 ? (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.to")} info={log.to} />
          ) : (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.recipient.number")} info={log.nrcpt} />
          )}

          {this.isAdminUser() ? (
            <>
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.subject")}
                info={this.formatSubject(log.subject)}
              />
              {log.reject_code && (
                <DetailInfo
                  className={s.detailInfo}
                  label={t("detailInfo.label.reject.message")}
                  info={log.reject_message}
                  error
                />
              )}
            </>
          ) : (
            log.reject_code && (
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.reject.message")}
                info={log.reject_message}
                error
              />
            )
          )}

          {log.sip_country_code && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.country")}
              info={
                <Tooltip
                  title={t("tooltip.country")}
                  text={emojiFlags[log.sip_country_code].name}
                  containerStyle={{ float: "right" }}
                >
                  <span className={s.flag}>{emojiFlags[log.sip_country_code].emoji}</span>
                </Tooltip>
              }
            />
          )}

          <div />

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.smtpID")} info={log.sid} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.server")} info={log.server} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.remoteIP")} info={log.sip} />
          )}

          {this.state.expanded && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.port")} info={port} />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.size")}
              info={bytesToHuman(log.size, true)}
            />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.DKIM.selector")}
              info={log.opendkim_selector || "-"}
            />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.DKIM.domain")}
              info={log.opendkim_domain || "-"}
            />
          )}

          {this.state.expanded && log.reject_code && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.reject.code")} info={log.reject_code} />
          )}

          {this.state.expanded && !this.isAdminUser() && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.subject")}
              info={this.formatSubject(log.subject)}
            />
          )}

          {this.state.expanded && (
            <DetailInfo
              className={cx(s.detailInfo, s.detailInfoFull)}
              label={t("detailInfo.label.messageID")}
              info={log.msg_id}
            />
          )}
        </div>

        {log.bounces && (
          <div
            className={cx(s.notificationLog, s.accordion, {
              [s.openAccordion]: this.state.expandedNotification,
            })}
          >
            <div className={s.headerAccordione} onClick={this.toggleNotification}>
              <Icon svg={flag} width="1rem" height="1rem" />
              <div>{t("etlive.log.accordion.notification")}</div>
              <Icon svg={this.state.expandedNotification ? arrowUp : arrowDown} width="1rem" height="1rem" />
            </div>

            {this.state.expandedNotification && log.bounces && this.renderBounces(log.bounces)}
          </div>
        )}

        {showDeliveries && (
          <div
            className={cx(s.deliveries, s.accordion, {
              [s.openAccordion]: this.state.expandedDelivery,
            })}
          >
            <div className={s.headerAccordione} onClick={this.toggleDelivery}>
              <Icon svg={mail} width="1rem" height="1rem" />
              <div>{t("etlive.log.accordion.deliveries")}</div>
              <Icon svg={this.state.expandedDelivery ? arrowUp : arrowDown} width="1rem" height="1rem" />
            </div>

            {this.state.expandedDelivery && log.deliveries && this.renderDeliveries(log.deliveries)}
          </div>
        )}
      </div>
    );
  };

  renderMailin = (log) => {
    const { isMediaMobile } = this.context;
    const { whereIsFolder, whereIsNotFound } = this.state;

    const spamScore = parseFloat(log.spam_score);
    const spamThreshold = parseFloat(log.spam_threshold);

    let isRejected = false;

    let colorClass;
    if (
      log.filter_action === "spam-reject" ||
      log.filter_action === "denied-rbl" ||
      log.filter_action === "virus-reject" ||
      log.filter_action === "denied-other" ||
      log.filter_action === "policy-reject" ||
      log.filter_action === "timeout"
    ) {
      colorClass = s.failed;
      isRejected = true;
    } else if (log.filter_action === "spam-mark") {
      colorClass = s.warning;
    }

    let attachments = [];

    if (log.attachments && log.attachments !== "") {
      attachments = this.formatAttachments(log.attachments);
    }

    let hasErrorsInDeliveries = false;
    if (log.deliveries) {
      for (let key in log.deliveries) {
        const action = log.deliveries[key].action;
        if (action === "storeerror" || action === "reject") {
          hasErrorsInDeliveries = true;
        }
      }
    }

    if (hasErrorsInDeliveries) colorClass = s.failed;

    return (
      <>
        <div className={cx(s.wrapLog, s.mailIn, { [colorClass]: true })}>
          <div className={s.headerLog}>
            <div className={s.statusCircle} />
            <div className={s.titleHeader}>
              {isRejected ? t("etlive.log.title.email.not.received") : t("etlive.log.title.email.received")}
            </div>

            {!isRejected && (
              <div
                onClick={() => this.whereIs(log)}
                className={cx(s.btnWhere, "internalLink", {
                  [s.exporting]: this.state[`${log._id}_where_inprogress`],
                })}
              >
                {this.state[`${log._id}_where_inprogress`]
                  ? t("etlive.log.locateMessageLoading")
                  : isMediaMobile()
                  ? t("etlive.log.locateMessageShort")
                  : t("etlive.log.locateMessage")}
              </div>
            )}

            <div
              onClick={() => this.exportPDF(log, { type: "mailin" })}
              className={cx(s.btnExport, "internalLink", {
                [s.exporting]: this.state[`${log._id}_exporting`],
              })}
            >
              {this.state[`${log._id}_exporting`]
                ? t("etlive.log.exporting")
                : isMediaMobile()
                ? t("etlive.log.exportPDF")
                : t("etlive.log.export")}
            </div>

            <div className={cx(s.btnMore, "internalLink")} onClick={this.toggleExpansion}>
              {this.state.expanded ? t("butto.info.hide") : t("butto.info.show")}
            </div>
          </div>
          <div className={s.contentLog}>
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.date")}
              info={log.datetime_in_timezone && new Date(log.datetime_in_timezone).toLocaleString()}
            />
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.user")}
              info={log.user + "@" + log.domain}
            />

            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.from")} info={log.from} />
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.to")} info={log.to} />
            <DetailInfo
              className={cx(s.detailInfo, s.detailInfoFull)}
              label={t("detailInfo.label.subject")}
              info={this.formatSubject(log.subject)}
            />

            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.filter")}
              info={log.filter_action}
              warning={log.filter_action === "spam-mark"}
              error={isRejected}
            />

            {(log.filter_action === "spam-reject" || log.filter_action === "spam-mark") && (
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.spam")}
                info={"Score: " + spamScore + " – " + "Threshold: " + spamThreshold}
                warning={log.filter_action === "spam-mark"}
                error={log.filter_action === "spam-reject"}
              />
            )}

            {this.state.expanded && log.filter_action === "virus-reject" && (
              <DetailInfo
                className={cx(s.detailInfo, s.detailInfoFull)}
                label={t("detailInfo.label.filter.detail")}
                info={log.filter_detail}
                error
              />
            )}

            {this.state.expanded && (
              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.server")} info={log.server} />
            )}

            {this.state.expanded && (
              <DetailInfo className={s.detailInfo} label={t("detailInfo.label.remoteServerHost")} info={log.sip} />
            )}

            {this.state.expanded && (
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.size")}
                info={bytesToHuman(log.size, true)}
              />
            )}

            {this.state.expanded && (
              <DetailInfo
                className={s.detailInfo}
                label={t("detailInfo.label.analisysTime")}
                info={log.elapsed + " secs"}
              />
            )}

            {this.state.expanded && (
              <DetailInfo
                className={cx(s.detailInfo, s.detailInfoFull)}
                label={t("detailInfo.label.messageID")}
                info={log.msgid}
              />
            )}
          </div>

          {attachments.length > 0 && (
            <div
              className={cx(s.attachLog, s.accordion, {
                [s.openAccordion]: this.state.expandedAttach,
              })}
            >
              <div className={s.headerAccordione} onClick={this.toggleAttach}>
                <Icon svg={attach} width="1rem" height="1rem" />
                <div>{t("etlive.log.accordion.attachments")}</div>
                <Icon svg={this.state.expandedAttach ? arrowUp : arrowDown} width="1rem" height="1rem" />
              </div>
              {this.state.expandedAttach && (
                <div className={s.contentAccordion}>
                  {attachments.map((obj) => (
                    <div className={s.singleAttachments}>
                      <DetailInfo
                        className={s.detailInfo}
                        label={t("detailInfo.label.file")}
                        info={this.getCensoredField(obj.name)}
                      />
                      <DetailInfo
                        className={s.detailInfo}
                        label={t("detailInfo.label.size")}
                        info={this.getCensoredField(bytesToHuman(obj.size))}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {log.deliveries && (
            <div
              className={cx(s.deliveries, s.accordion, {
                [s.openAccordion]: this.state.expandedDelivery,
              })}
            >
              <div className={s.headerAccordione} onClick={this.toggleDelivery}>
                <Icon svg={mail} width="1rem" height="1rem" />
                <div>{t("etlive.log.accordion.deliveries")}</div>
                <Icon svg={this.state.expandedDelivery ? arrowUp : arrowDown} width="1rem" height="1rem" />
              </div>

              {this.state.expandedDelivery &&
                log.deliveries &&
                this.renderDeliveriesMailins(log.deliveries, colorClass)}
            </div>
          )}
        </div>
        {whereIsNotFound && (
          <Modal
            title={t("modal.etlive.whereIsTitle")}
            closeModal={() => this.setState({ whereIsNotFound: null })}
            opened={!!whereIsNotFound}
            onEnter={() => this.setState({ whereIsNotFound: null })}
          >
            <div>
              <TranslatedString
                subs={{
                  recipient: this.state.selectedLog.user + "@" + this.state.selectedLog.domain,
                  delivered_at: new Date(this.state.selectedLog.datetime_in_timezone).toLocaleString(),
                }}
              >
                etlive.log.locatingMessageNotFound
              </TranslatedString>
            </div>

            <div>
              <Button onClick={() => this.setState({ whereIsNotFound: null })} type="button" color="green">
                button.ok
              </Button>
            </div>
          </Modal>
        )}
        {whereIsFolder && (
          <Modal
            title={t("modal.etlive.whereIsTitle")}
            closeModal={() => this.setState({ whereIsFolder: null })}
            opened={!!whereIsFolder}
            onEnter={() => this.setState({ whereIsFolder: null })}
          >
            <div>
              <TranslatedString
                subs={{
                  recipient: this.state.selectedLog.user + "@" + this.state.selectedLog.domain,
                  delivered_at: new Date(this.state.selectedLog.datetime_in_timezone).toLocaleString(),
                }}
              >
                etlive.log.locatingMessage
              </TranslatedString>
              <ul className={s.folderList}>
                {whereIsFolder.map((f) => (
                  <li>
                    <b>{f}</b>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <Button onClick={() => this.setState({ whereIsFolder: null })} type="button" color="green">
                button.ok
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  };

  render() {
    const { type, log } = this.props;
    if (type === "accesses") return this.renderAccess(log);
    if (type === "mailouts") return this.renderMailout(log);
    if (type === "mailins") return this.renderMailin(log);
  }
}

ETLiveLog.contextTypes = ContextTypes;

export default ETLiveLog;
